export enum MediaType {
    Video = "Video",
    InteractiveLesson = "Interactive Lesson",
    Interactive = "Interactive",
    LessonPlan = "Lesson Plan",
    MediaGallery = "Media Gallery",
    Audio = "Audio",
    Image = "Image",
    Document = "Document",
    Webpage = "Webpage",
    Collection = "Collection",
}

export enum GtmEvent {
    MediaStart = "mediastart",
    MediaPause = "mediapause",
    MediaStop = "mediastop",
}

export enum VideoPlayerInfo {
    VideoTitle = "video_title",
    ShowTitle = "show_title",
    Guid = "video_tp_media_id",
}

export enum GtmDimensions {
    SiteSubdomain = "site_subdomain", // ua_dimension_1
    ResourceSubject = "resource_subject", // ua_dimension_2
    ContentProject = "content_project", // ua_dimension_3
    ResourceGradeLevel = "resource_grade_level", // ua_dimension_4
    PostalCode = "postal_code", // ua_dimension_5
    UserOrganization = "user_organization", // ua_dimension_6
    UserRole = "user_role", // ua_dimension_7
    UserPreferredSubject = "user_preferred_subject", // ua_dimension_8
    UserGradeLevel = "user_grade_level", // ua_dimension_9
    LoginStatus = "login_status", // ua_dimension_10
    ResourceBrand = "resource_brand", // ua_dimension_11
    ResourceProjectType = "resource_project_type", // dimension12
    ResourceOrganization = "resource_organization", // ua_dimension_13
    ResourceMediaType = "resource_media_type", // ua_dimension_14
    UserSchool = "user_school", // ua_dimension_15
    AssignmentCode = "assignment_code", // ua_dimension_16
    StationLocalized = "station_localized", // ua_dimension_18
    Experience = "experience", // ua_dimension_19
    ForUserStaffInformation = "for_user_staff_information", // dimension20
    LastPageTitle = "last_page_title", // ua_dimension_22
    LastPageUrl = "last_page_url", // ua_dimension_24
    IsStudent = "is_student", // ua_dimension_26
    VideoData = "video_data", // ua_dimension_27
    ResourceCollection = "resource_collection", // ua_dimension_28
    ResourceSubcollection = "resource_subcollection", // dimension29
    SelectedStudentGrade = "selected_student_grade", // ua_dimension_30
    GameTitle = "game_title", // dimension31
    ShowTitle = "show_title", // dimension32
    GameGuid = "game_guid", // dimension33
    ShowGuid = "show_guid", // dimension34
    ResourceId = "resource_id", // dimension35
}
